import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=0bfe0b66&scoped=true&"
import script from "./afterDetail.vue?vue&type=script&lang=js&"
export * from "./afterDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterDetail.vue?vue&type=style&index=0&id=0bfe0b66&lang=less&scoped=true&"
import style1 from "./afterDetail.vue?vue&type=style&index=1&id=0bfe0b66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe0b66",
  null
  
)

export default component.exports